<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Producer Rate"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedProducerRates"
      :columns="columns"
      :total-rows="totalProducerRates"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'ProducerRateTable',
  components: {
    BaseTable
  },
  data() {
    return {
      producerRates: [],
      totalProducerRates: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'prod_name', align: 'left', label: 'Producer Name', field: 'prod_name', sortable: true },
        { name: 'crop_name', align: 'left', label: 'Crop', field: 'crop_name', sortable: true },
        { name: 'description', align: 'left', label: 'Description', field: 'description', sortable: true },
        { name: 'rate', align: 'right', label: 'Rate', field: 'rate', sortable: true },
        { name: 'moisture', align: 'right', label: 'At Moisture (%)', field: 'moisture', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedProducerRates() {
      return this.producerRates.map(rate => ({
        ...rate,
        prod_name: rate.producer_id.name, // Assuming the API returns nested producer object with `name`
        crop_name: rate.crop_id.crop, // Assuming the API returns nested crop object with `crop`
        add_date: new Date(rate.add_date).toLocaleDateString(),
        edit_date: new Date(rate.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchProducerRates();
  },
  methods: {
    fetchProducerRates() {
      axios
        .get('/api/v1/producer_rate/producer_rates/')
        .then(response => {
          this.producerRates = response.data;
          this.totalProducerRates = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching producer rates:', error);
        });
    },
    onAdd() {
      this.$router.push('/producer_rate/add');
    },
    getEditUrl(row) {
      return `/producer_rate/edit/${row.id}`;
    }
  },
  watch: {
    producerRates() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the ProducerRateTable here */
</style>
